
<template>
  <v-container v-if="loading">
    <div class="text-xs-center">
      <v-progress-circular indeterminate :size="150" :width="8" color="blue"></v-progress-circular>
    </div>
  </v-container>

  <v-container v-else grid-list-xl class="container">
    <v-toolbar dark>
      <v-toolbar-title class="width" app>
        <v-text-field
          text
          al
          placeholder="Search Your Favourite Movie"
          v-model="searchText"
          :rules="searchRules"
          v-on:keyup.enter='searchMovie'
          required
        />
      </v-toolbar-title>

      <v-btn icon @click="searchMovie">
        <v-icon>mdi-magnify</v-icon>
      </v-btn>

      <div>
        <img src="../image/reel2.png" alt="reel-img" id="reel" />
      </div>
    </v-toolbar>

    <transition appear name="bounce">
      <h2>Movie Magic</h2>
    </transition>

    <v-layout wrap class="row">
      <v-flex v-for="(item, index) in wholeResponse" :key="index" mt-10 >
        <v-card 
        class="col button mx-auto" 
        max-width="320" 
        min-width="320" 
        min-height="500"
        @click="singleMovie(item.imdbID)">
          <v-img :src="item.Poster" alt="item.Title" aspect-ratio="1" />

          <v-card-title primary-title hover>
            <h4>{{item.Title}}</h4>
          </v-card-title>

          <div class="movie-text">
            <div>Year: {{item.Year}}</div>
            <div>Type: {{item.Type}}</div>
          </div>

        </v-card>
      </v-flex>
    </v-layout>

    <v-footer class="text-center footer" app dark>
      <strong>
        Subash Pradhan
        {{ new Date().getFullYear() }}
        @Codaisseur 🤙
      </strong>
    </v-footer>
  </v-container>
</template>

<script>
import axios from "axios";

export default {
  name: "LatestMovie",
  data() {
    return {
      wholeResponse: [],
      valid: true,
      loading: true,
      searchText: "",
      searchRules: [v => !!v || "Please Enter a Valid Movie Name"]
    };
  },
  mounted() {
    axios
      .get(
        "https://www.omdbapi.com/?s=animation&apikey=d03e9c79&page=1&type=movie&Content-Type=application/json"
      )
      .then(response => {
        this.wholeResponse = response.data.Search;
        this.loading = false;
      })
      .catch(error => {
        console.log(error);
      });
  },
  methods: {
    singleMovie(id) {
      this.$router.push("/movie/" + id);
    },

    searchMovie() {
      if (!this.searchText) {
        this.snackbar = true;
      } else {
        this.$router.push("/movie-search/" + this.searchText);
        this.searchText = "";
      }
    }
  }
};
</script>
<style lang='stylus' scoped>
.v-progress-circular {
  margin: 1rem;
}

.movie-text,
 h4 {
  text-align: center;
  font-family: 'Courgette', cursive;
}

.width {
  width: 100%;
  min-width: auto;
}

.button:hover {
  color: black;
  transition: 0.8s ease-in-out;
  transform: scale(1.1, 1.1);
  cursor: pointer;
}

#reel {
  min-width: auto;
  min-height: auto;
  height: 75px;
  width: 75px;
  -webkit-animation: rotation 2s infinite linear;
}

@keyframes rotation {
  from {
    -webkit-transform: rotate(0deg);
  }

  to {
    -webkit-transform: rotate(359deg);
    transition: 0.9s;
  }
}

.container {
  background-image: url('../image/giphy.gif');
  background-size: cover;
  background-attachment: fixed;
  background-position: center;
}

h2 {
  color: red;
  text-align: center;
  font-family: 'Kaushan Script', cursive;
  font-size: 40px;
}

.footer {
  justify-content: center;
}

.bounce-enter-active {
  animation: bounce-in 0.9s;
}

@keyframes bounce-in {
  0% {
    transform: scale(0);
  }

  50% {
    transform: scale(2);
  }

  100% {
    transform: scale(1);
  }
}
</style>
